import { PickupAddressApi } from '../../generated/api';
import configuration from './configuration';

export default new PickupAddressApi(configuration);
